module.exports = __webpack_public_path__ + "img/nosotros_16-9_640.4d2d76b0.jpg";